import React from 'react';
import { ReactComponent as Sortable } from 'styles/icons/sortable.svg';

const style = {
  color: '#4a4a4a',
  height: '20px',
  width: '20px',
  padding: '5px',
  zIndex: '1',
};

const SortableIcon = (props) => {
  return <Sortable style={style} {...props} />;
};

export default SortableIcon;
